<template>
  <v-dialog v-model="dialog" :max-width="$vuetify.breakpoint.xsOnly ? '' : '600'" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
    <v-card v-if="quotation">
      <v-toolbar dark color="primary" flat>
        <v-toolbar-title>{{ $t('quotations.review_request.title') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark :title="$t('close')" :disabled="busy" @click="dialog = false"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pt-5 gradient-icons">
        <div class="body-2 mb-4">{{ $t('quotations.review_request.help') }}</div>
        <v-autocomplete
          v-model="userId"
          :items="users"
          :loading="loadingUsers"
          :item-text="userName"
          item-value="id"
          :label="`${$t('quotations.review_request.recipient')} *`"
          :no-data-text="$t('quotations.review_request.no_recipients')"
          outlined
          dense
          hide-details
          class="mb-4"
        >
          <template v-slot:prepend><v-icon>mdi-account-check-outline</v-icon></template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ userName(item) }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-textarea v-model="message" :label="$t('quotations.review_request.message')" outlined dense hide-details auto-grow rows="3">
          <template v-slot:prepend><v-icon>mdi-message-text-outline</v-icon></template>
        </v-textarea>
      </v-card-text>
      <v-divider />
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer />
        <v-btn :block="$vuetify.breakpoint.xsOnly" text :disabled="busy" @click="dialog = false">{{ $t('cancel') }}</v-btn>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          :class="$vuetify.breakpoint.xsOnly && 'mb-2'"
          color="primary"
          :loading="busy"
          :disabled="!userId"
          @click="send"
        >
          <v-icon left>mdi-email-send-outline</v-icon>
          {{ $t('quotations.review_request.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import quotationApi from '@/api/quotation';
import tenantApi from '@/api/tenant';
import { ROLES } from '@/config/roles';

// Tarkistuspyyntö toiselle käyttäjälle sähköpostilla. Vastaanottajiksi vain Hallinto-käyttäjät,
// koska muut eivät pääse tarjouksiin; palvelin tarkistaa saman.
export default {
  name: 'ReviewRequestDialog',
  data() {
    return {
      dialog: false,
      busy: false,
      quotation: null,
      loadingUsers: false,
      users: [],
      userId: null,
      message: '',
    };
  },
  methods: {
    open(quotation) {
      this.quotation = quotation;
      this.userId = null;
      this.message = '';
      this.dialog = true;
      this.loadUsers();
    },
    async loadUsers() {
      this.loadingUsers = true;
      try {
        const users = await tenantApi.loadTenantUsers();
        const me = this.$userInfo && this.$userInfo.id;
        this.users = users
          .filter(u => u.enabled && u.roles.includes(ROLES.TENANT_ADMIN) && u.id !== me)
          .sort((a, b) => this.userName(a).localeCompare(this.userName(b), 'fi'));
      } catch (error) {
        this.$handleApiError(error);
      }
      this.loadingUsers = false;
    },
    userName(user) {
      return [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;
    },
    async send() {
      this.busy = true;
      try {
        await quotationApi.requestReview(this.quotation.id, this.userId, this.message);
        this.$emit('sent', this.users.find(u => u.id === this.userId));
        this.dialog = false;
      } catch (error) {
        this.$handleApiError(error, error && error.message);
      }
      this.busy = false;
    },
  },
};
</script>
